import React from "react";

const SingleChoiceInput = ({label, formik, name, options, onChange, error = false}) => {
    const {errors, touched} = formik;
    const showError = (!errors[name] && error) || (touched[name] && errors[name]);

    return (
        <div className="sl-width-100 sl-text-left sl-flex sl-flex-col">
            <span
                className="sl-font sl-font-medium sl-text-sm sl-text-gray-700"
                dangerouslySetInnerHTML={{__html: label}}
            />
            <div
                className={`sl-mt-2 sl-flex sl-gap-4 sl-items-center ${showError ? 'sl-border-1 sl-border-solid sl-border-error-300' : ''}`}
            >
                {options.map((option) => (
                    <label key={option.value} className="sl-flex sl-items-center">
                        <input
                            type="radio"
                            name={name}
                            value={option.value}
                            checked={formik.values[name] === option.value}
                            onChange={onChange}
                            className="sl-radio"
                        />
                        <span className="sl-ml-2 sl-font sl-text-sm sl-text-gray-900">{option.label}</span>
                    </label>
                ))}
            </div>
            {showError && (
                <span className="sl-text-error-500 sl-mt-2 sl-font sl-text-sm sl-font">
                    {errors[name]}
                </span>
            )}
        </div>
    );
};

export default SingleChoiceInput;
